import { Link } from 'gatsby';
import React from 'react';
import moment from 'moment';
import { RichText } from '../rich-text';
import { TitleDivider } from '../title-divider';

export class FestivalTwoColumns extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <>
        { this.props.eyebrow && <TitleDivider>{ this.props.eyebrow }</TitleDivider> }
        <section className="festival-two-columns">
          <Link to={this.props.targetLeft.slug} className="festival-two-columns__festival" style={{ backgroundColor: this.props.festivalLeft.color }}>
            <h4 className="festival-two-columns__festival__title">
              <RichText document={this.props.titleLeft} />
            </h4>
            <div className="festival-two-columns__festival__image"><img src={this.props.imageLeft.file.url} /></div> 
            <div className="festival-two-columns__festival__date">
              { this.props.showDateLeft && (
                <>
                  { moment(this.props.festivalLeft.startDate).format('DD.MM.YYYY') }<br/>
                  { moment(this.props.festivalLeft.endDate).format('DD.MM.YYYY') }
                </>
              )}
              
            </div>
          </Link>
          <Link to={this.props.targetRight.slug} className="festival-two-columns__festival" style={{ backgroundColor: this.props.festivalRight.color }}>
            <h4 className="festival-two-columns__festival__title">
              <RichText document={this.props.titleRight} />
            </h4>
            <div className="festival-two-columns__festival__image"><img src={this.props.imageRight.file.url} /></div> 
            <div className="festival-two-columns__festival__date">
              { this.props.showDateRight && (
                <>
                  { moment(this.props.festivalRight.startDate).format('DD.MM.YYYY') }<br/>
                  { moment(this.props.festivalRight.endDate).format('DD.MM.YYYY') }
                </>
              )}
            </div>
          </Link>
        </section>
      </>
    );
  }
}
